import { Component, OnInit } from '@angular/core';
import {
  selectGroupCode,
  selectPrfName,
  selectPrfNumber,
  selectPrfYear,
} from 'src/app/store/selectors/app.selector';
import { Store } from '@ngrx/store';
import { CompanyService } from '../company.service';
import { Router } from '@angular/router';
import { ReportRow } from './submissionreview.model';
import { filter, forkJoin, take } from 'rxjs';
import { SubmissionSummaryService } from './data-access/services/submission-summary.service';
import { generatePdfFromComponent } from './data-access/helpers/download-pdf-utility';

@Component({
  selector: 'app-submissionreview',
  templateUrl: './submissionreview.component.html',
  styleUrls: ['./submissionreview.component.scss'],
  standalone: false,
})
export class SubmissionreviewComponent implements OnInit {
  generatePdf = generatePdfFromComponent;
  compno: any;
  groupCode: any;
  currentYear: number;
  prfNumber: string;
  prfName: string;
  downloadingReport = false;
  validationSummaryItem$;
  validationItems: any[] = [];
  rows: ReportRow[] = [
    {
      number: 1,
      title: 'Company Information',
      icon: 'company',
    },
    {
      number: 2,
      title: 'Group Reporting',
      icon: 'group',
    },
    {
      number: 3,
      title: 'Annual Statement',
      icon: 'statement',
    },
    {
      number: 4,
      title: 'Premium Report',
      icon: 'premium',
    },
    {
      number: 5,
      title: 'User Defined Data',
      icon: 'userdefined',
    },
    {
      number: 6,
      title: 'Comments',
      icon: 'comments',
    },
    {
      number: 7,
      title: 'Validation Summary',
      icon: 'validation',
    },
  ];
  constructor(
    private readonly store: Store,
    private readonly companyService: CompanyService,
    private readonly router: Router,
    private readonly submissionSummaryService: SubmissionSummaryService
  ) {}
  ngOnInit() {
    this.store.select(selectPrfNumber).subscribe((prfNumber) => {
      this.prfNumber = prfNumber || '';
      this.compno = prfNumber || '';
    });

    this.store.select(selectPrfYear).subscribe((year) => {
      this.currentYear = year;
    });

    this.store.select(selectGroupCode).subscribe((groupCode) => {
      this.groupCode = groupCode;
      if (!this.groupCode) {
        this.companyService.getgroup().subscribe((value) => {
          this.groupCode = value;
        });
      }
    });
    this.store.select(selectPrfName).subscribe((prfName) => {
      this.prfName = prfName;
    });
    this.submissionSummaryService.loadValidationSummaryData();
    this.getProgress();
  }

  expandAll() {
    this.rows.forEach((r) => (r.expanded = true));
  }
  collapseAll() {
    this.rows.forEach((r) => (r.expanded = false));
  }

  toggle(row: ReportRow) {
    row.expanded = !row.expanded;
  }
  getProgress() {
    this.companyService
      .getCustomerPrfProgress(this.currentYear, this.compno, this.groupCode)
      .subscribe({
        next: (resp) => {
          if (resp['message'] == 'Success') {
            console.log('Progress data loaded successfully');
          }
        },
        error: (error) => {
          this.router.navigate(['/apifailure']);
        },
      });
  }

  async downloadFullReport() {
    this.downloadingReport = true;
    forkJoin({
      companyInfo: this.submissionSummaryService.loadCompanyInfo(
        this.currentYear,
        this.prfNumber,
        this.groupCode
      ),
      premiumDetails: this.submissionSummaryService.loadPremiumDetails(
        this.prfNumber,
        this.currentYear,
        this.groupCode
      ),
      annualStatement: this.submissionSummaryService.getAnnualStatement(
        this.currentYear,
        this.prfNumber
      ),
      isoLines: this.submissionSummaryService.getIsoLines(
        this.currentYear,
        this.prfNumber
      ),
      comments: this.submissionSummaryService.getComments(
        this.currentYear,
        this.prfNumber,
        this.groupCode
      ),
      groupReporting: this.submissionSummaryService.loadGroupReporting(
        this.currentYear,
        this.prfNumber,
        this.groupCode
      ),
      // load user-defined column metadata so PDF can include "Details of custom columns added"
      userDefinedCols: this.submissionSummaryService.loadUserdefinedColumns(
        this.currentYear,
        this.prfNumber
      ),
    }).subscribe({
      next: (results) => {
        console.log('All data loaded for PDF generation', results);

        this.submissionSummaryService.loadValidationSummaryData();

        this.submissionSummaryService
          .selectValidationSummaryData()
          .pipe(
            filter((data) => Array.isArray(data?.data) && data.data.length > 0),
            take(1)
          )
          .subscribe({
            next: (validationData) => {
              const submissionReviewData = {
                companyInfo: results.companyInfo,
                premiumDetails: results.premiumDetails,
                annualStatement: results.annualStatement,
                selectedIsoLines:
                  this.submissionSummaryService.getSelectedIsoLine(
                    results.isoLines
                  ),
                comments: results.comments,
                groupReporting:{
                  includedList: this.submissionSummaryService.getGroupReportingIncludedList(
                    results.groupReporting.groupcompanydetails
                  ),
                  isGroupReporting: results.groupReporting.groupreporting,
                },
                // include user defined columns if available
                userDefinedCols: results.userDefinedCols || [],
                validationSummary: validationData.data,
              };

              console.log(
                'Submission Review Data for PDF:',
                submissionReviewData
              );

              this.generatePdf(submissionReviewData, this.prfNumber, this.prfName, this.currentYear, { filename: `Submission Summary Report_${this.prfNumber}_${this.currentYear}.pdf`, scale: 1.25 })
                .catch((err) => {
                  console.error('PDF generation failed', err);
                })
                .finally(() => {
                  this.downloadingReport = false;
                });
            },
            error: () => {
              this.downloadingReport = false;
              this.router.navigate(['/apifailure']);
            }
          });
      },
      error: () => {
        this.downloadingReport = false;
        this.router.navigate(['/apifailure']);
      },
    });
  }
}
